import { faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Button } from 'react-bootstrap';

interface DeleteButtonComponentProps{
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
}

const DeleteButtonComponent:React.FC<DeleteButtonComponentProps> = ({onClick, disabled = false, loading = false}) => {
  return (
   <>
   <Button variant='light' onClick={onClick} disabled={disabled || loading}>
    <FontAwesomeIcon 
      icon={loading ? faSpinner : faTrash} 
      color={disabled || loading ? '#ccc' : '#F24E1E'}
      spin={loading}
    />
   </Button>
   </>
  )
}

export default DeleteButtonComponent;